// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import FieldView from '../utils/FieldView';
import Image from '../utils/Image';
import { GROUND_TRAVEL, BUS_TRAVEL } from '../forms/events/EventCategory';
import { getEventImage } from '../forms/events/EventManager';
import '../../styles/components/FilterPanel.css';
import { getCreatedFrom } from '../../infrastructure/utils/events';
import CollapsableItem from '../utils/CollapsableItem';
import { isMobileResolution } from '../../infrastructure/utils/common';
import { getConfig } from '../../config';

class EventView extends React.PureComponent {
  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      name,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      dates,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      party,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      attendees,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      title,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      allMembers,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      activity,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      images,
    } = this.props;
    let center = null;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    let address = event.eventLocation ? event.eventLocation.address : '';
    if (!address) {
      address = '';
    }
    const frame =
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.eventCategory !== GROUND_TRAVEL &&
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.eventCategory !== BUS_TRAVEL &&
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.eventLocation &&
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.eventLocation.latitude && // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.eventLocation.longitude;
    if (frame) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      center = {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        lat: event.eventLocation.latitude,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        lng: event.eventLocation.longitude,
      };
    }
    const image = getEventImage(event, images);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { google } = this.props;
    const notAvailableLabel = 'n/a';

    const config = getConfig();

    return (
      <Fragment>
        <div className='media'>
          <div className='media-left'>
            <Image src={image} width='200px' height='200px' alt='event' />
          </div>
          <div className='media-body'>
            <h1 style={{ fontSize: '30px', fontWeight: 'bold' }}>{title}</h1>
            <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>{name}</h2>
            <div className='event-dates'>
              <i className='fas fa-clock' />
              {dates}
            </div>
            <div className={!isMobileResolution() ? 'data-box' : ''}>
              <FieldView name='Type' md={2} vmd={6}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.eventCategory}
              </FieldView>
              <FieldView name='Created At:' md={2} vmd={6}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.createdAt
                  ? // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    moment(event.createdAt) // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line react/prop-types
                      .tz(event.startTz)
                      .format('MM/DD/YYYY')
                  : notAvailableLabel}
              </FieldView>
              <FieldView name='Party:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.partyId ? (
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  <a href={`/party/${party.partyId}`}>{party.partyName}</a>
                ) : (
                  notAvailableLabel
                )}
              </FieldView>
              <FieldView name='Created From:' md={2} vmd={4}>
                {getCreatedFrom(event, activity, party)}
              </FieldView>
              <FieldView name='Activity:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.activityId ? (
                  <a
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    href={`${config.batchAdminURL}/experiences/${event.activityId}`}
                  >
                    View activity
                  </a>
                ) : (
                  notAvailableLabel
                )}
              </FieldView>
              {frame ? (
                <div className='location'>
                  <FieldView name='Address' md={2} vmd={8} vsm={8}>
                    <div className='map-description'>
                      <i
                        className='fas fa-map-marker-alt'
                        style={{ marginRight: '10px' }}
                      />
                      {address}
                    </div>
                    <div className='map-frame'>
                      <Map
                        google={google}
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        initialCenter={center}
                        style={{
                          width: '70%',
                          height: '400px',
                          border: 'none',
                        }}
                        Zoom={11}
                      >
                        <Marker position={center} />
                      </Map>
                    </div>
                  </FieldView>
                </div>
              ) : (
                <FieldView name='Location:' md={2} vmd={4}>
                  {address.length > 0 ? address : notAvailableLabel}
                </FieldView>
              )}
              <FieldView name='Duration:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.duration || notAvailableLabel}
              </FieldView>
              <FieldView name='Budget Type:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.costType || notAvailableLabel}
              </FieldView>
            </div>
            <div
              className={!isMobileResolution() ? 'data-box' : ''}
              style={{ margin: '20px 0', position: 'relative' }}
            >
              <div style={{ fontSize: '18px', textDecoration: 'underline' }}>
                Optional Details:
              </div>
              <CollapsableItem top={isMobileResolution() ? '-31px' : ''}>
                <FieldView name='Est.Budget:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.cost && event.costType
                    ? // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line react/prop-types
                      event.cost
                    : notAvailableLabel}
                </FieldView>
                <FieldView name='Surprise Event:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.isSecret ? 'Yes' : 'No'}
                </FieldView>
                <FieldView name='Dress Code:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.dressCode || notAvailableLabel}
                </FieldView>
                <FieldView name='Attendees:' md={2} vmd={4}>
                  <div style={{ fontWeight: '600' }}>
                    {/* TODO: Fix this the next time the file is edited. */}
                    {/* eslint-disable-next-line react/prop-types */}
                    {attendees.length}/{allMembers.length}party members:
                  </div>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {attendees.map(member => (
                    <div key={member.memberId} className='row memb-descr'>
                      {member.memberName}
                    </div>
                  ))}
                </FieldView>
                <FieldView name='Additional Notes:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.eventDescription || notAvailableLabel}
                </FieldView>
              </CollapsableItem>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBAAIr9HbcVCnLHgCw8WXXdLV47unpA_I8',
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
})(EventView);
